import { useEffect } from "react";
import { IStaffTechnologyResouce } from "../../../../../models/dashboard/staffDashboard";
import { getTechnologyResources } from "../../../../../action/masters/technologyResourceActionCreator";
import { connect, useDispatch } from "react-redux";
import { pageBlockId } from "../../../../../constants/pageBlocks";
import { setTechnologyResources } from "../../../../../store/slices/master/technologyResourceSlice";
import { baseURL } from "../../../../../constants/commonConstants";
import { ITechnologyResources } from "../../../../../models/master/technologyResource";

const TechnologyResourcesViewAll = (props: IStaffTechnologyResouce) => {
  const { getTechnologyResources, technologyResources } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    getTechnologyResources(pageBlockId.technologyResources, undefined);
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setTechnologyResources([]));
    };
  }, []);

  return (
    <>
      <div className="widgets">
        <div className="title">
          <h2>All Technology Resources</h2>
        </div>
        <div className="card-wrap">
          <div className="row">
            {technologyResources?.map((alert: ITechnologyResources) => (
              <div className="col-md-12 mb-3" key={alert.id}>
                <div className="resourcecard icon-visibility">
                  <a href={alert.url} target="_blank" className="h-100">
                    <div className="img">
                      <img src={baseURL + alert.image} alt="" />
                    </div>
                    <div className="dtls">
                      <h3 className="para-hide-1">{alert.resourceName}</h3>
                      <p className="para-hide-2">{alert.description}</p>
                    </div>
                    <span>
                      <img src="/assets/images/icon/arrow-right.svg" alt="" />
                    </span>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
const mapDispatchToProps = {
  getTechnologyResources: (pageBlockId?: number, noOfItems?: number) =>
    getTechnologyResources(undefined, pageBlockId, undefined, undefined, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    technologyResources: state.technologyResource.technologyResources,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TechnologyResourcesViewAll);
